import classNames from 'classnames';
import Image from 'next/image';
import PropTypes from 'prop-types';

import classes from './index.module.css';

const Content = ({ title, value, icon, alt, isInteractive }) => (
  <>
    <div>
      {title && (
        <div className={classNames(classes.title, { [classes.interactive]: isInteractive })}>
          {title}
        </div>
      )}
      {value && (
        <div className={classNames('z-font-20 z-font-600 z-mt-2 z-mb-4', classes.value)}>
          {value}
        </div>
      )}
    </div>
    {icon && (
      <div className={classNames('d-flex align-items-center justify-content-center', classes.icon)}>
        <Image
          width="60"
          height="60"
          src={icon}
          alt={alt || title}
          placeholder="blur"
          blurDataURL="/ui-router/images/placeholder.png"
        />
      </div>
    )}
  </>
);

Content.propTypes = {
  title: PropTypes.string,
  value: PropTypes.node,
  icon: PropTypes.string,
  alt: PropTypes.string,
  isInteractive: PropTypes.bool,
};

Content.defaultProps = {
  title: '',
  value: '',
  icon: '',
  alt: '',
  isInteractive: false,
};

export default Content;
